import { FC, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/ReduxHooks";
import { verification } from "../../../redux/requests/IdentificationRequests";

const LoadingPage: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");
  const legal_entity = searchParams.get("legal_entity");

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (token && legal_entity) {
      localStorage.setItem("jwt", token);
      localStorage.setItem("legal_entity", legal_entity);
      console.log("auth Loading Page");
      dispatch(verification(token)).then((data) => {
        if (data.isPass)
          if (data.data.is_admin) navigate("/admin-panel");
          else navigate("/inn-check");
        else navigate("/");
      });
    }
  }, [token]);

  // useEffect(() => {
  //   console.log(data);
  //   if (data) navigate("/");
  // }, [data]);

  // useEffect(() => {
  //   console.log(isError);
  //   if (isError) navigate("/403");
  // }, [isError]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center space-y-4">
        <svg
          className="animate-spin h-12 w-12 text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
        <p className="text-gray-600 text-lg font-medium">Загрузка...</p>
      </div>
    </div>
  );
};

export default LoadingPage;
